/* eslint-disable no-plusplus */
/* eslint-disable max-len */
import React from 'react';
import { Typography, Button } from '@mui/material';
import { FaPause, FaPlay } from 'react-icons/fa';
import { Loader } from 'src/components';
import { AssessmentData } from '../types';

interface AssessmentDetailsProps {
  assessmentData: AssessmentData | null;
  assessmentFetching: boolean;
}

function AssessmentDetails({ assessmentData, assessmentFetching }: AssessmentDetailsProps) {
  const [audio, setAudio] = React.useState<HTMLAudioElement | null>(null);
  const [isPlaying, setIsPlaying] = React.useState(false);
  const [currentQuestion, setCurrentQuestion] = React.useState<number | null>(null);

  const handlePlayPause = (audioFilePath: string, questionNumber: number) => {
    if (audio && currentQuestion === questionNumber) {
      if (isPlaying) {
        audio.pause();
      } else {
        audio.play();
      }
      setIsPlaying(!isPlaying);
    } else {
      if (audio) {
        audio.pause();
      }
      const newAudio = new Audio(audioFilePath);
      newAudio.play();
      newAudio.addEventListener('ended', () => {
        setIsPlaying(false);
      });
      setAudio(newAudio);
      setIsPlaying(true);
      setCurrentQuestion(questionNumber);
    }
  };

  if (assessmentFetching) {
    return <Loader />;
  }

  if (!assessmentData) {
    return <Typography>No assessment data available.</Typography>;
  }

  return (
    <div className="">
      {assessmentData.recruiter_feedback && (
        <div className="mb-4 flex flex-col">
          <Typography variant="h6" className="mb-4 text-gray-700">
            AI Feedback:
          </Typography>
          <Typography variant="body2" className="mb-4 text-gray-700">
            {assessmentData.recruiter_feedback}
          </Typography>
        </div>
      )}
      {assessmentData.questions_answers.map((question) => (
        <div key={question.question_number} className="border-gray-200  shadow-md rounded-lg bg-white mb-6 p-6 flex flex-col justify-between md:flex-row">
          <div className="max-w-5xl">
            <Typography variant="body1" className="font-semibold text-gray-800">
              Question
              {' '}
              {question.question_number}
              :
              {' '}
              {question.question_text.replace(/^Question:\s*/i, '').replace(/^Question:\s*/i, '')}
            </Typography>
            <Typography variant="body2" className="mt-2 text-gray-600">
              <span className="font-medium text-gray-700">Answer:</span>
              {' '}
              {question.transcribed_text.includes('MBC 뉴스 이덕영입니다.')
                ? 'No answer is provided by candidate'
                : question.transcribed_text}
            </Typography>
          </div>
          <div className="flex flex-col md:ml-4">
            <Typography variant="body2" className="mt-1 text-gray-500">
              <span className="font-medium text-gray-700">AI Score:</span>
              {' '}
              {question.question_score}
            </Typography>
            {question.response_audio_file_path && (
              <div className="flex items-center mt-4">
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  onClick={() => handlePlayPause(question.response_audio_file_path, question.question_number)}
                  className="flex justify-center items-center rounded-full w-10 h-10"
                >
                  {isPlaying && currentQuestion === question.question_number ? <FaPause /> : <FaPlay />}
                </Button>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default AssessmentDetails;
